import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AhsSplashComponent } from './ahs-splash.component';
import { AhsSplashService } from '../../core/services/ahs-splash.service';
//import { AhsSplashService } from './ahs-splash.service';

@NgModule({
	declarations: [AhsSplashComponent],
	exports: [AhsSplashComponent],
	imports: [CommonModule, FlexLayoutModule],
	providers: [AhsSplashService]
})
export class AhsSplashModule {}
